<template>
  <div
    class="flex items-center gap-1"
    role="tablist"
    aria-label="Slide indicators"
  >
    <button
      v-for="i in count"
      :key="i"
      :aria-current="currentIndex === i - 1 ? 'true' : 'false'"
      :aria-label="`Go to slide ${i}`"
      class="h-1 rounded-full transition-[width,opacity] duration-300 ease-in-out will-change-[width,opacity] focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 focus-visible:ring-offset-2"
      :class="
        currentIndex === i - 1
          ? 'w-4 bg-anthracite-900 opacity-100'
          : 'w-1 bg-anthracite-900 opacity-50'
      "
      @click="$emit('updateCurrentIndex', i - 1)"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  count: number
  currentIndex: number
}>()

defineEmits<{
  updateCurrentIndex: [value: number]
}>()
</script>
